import { execFile } from 'node:child_process'
import { promisify } from 'node:util'

const execFileAsync = promisify(execFile)

/**
 * Check whether an npm package is reachable via npx WITHOUT forcing a
 * network download.
 *
 * By default `npx <pkg> --version` invokes `npm install <pkg>` on first run
 * (npm's on-demand install behavior), which fails with ECONNRESET on
 * unstable networks even when the candidate is happy to use the package
 * once it is cached.
 *
 * Using `npx --no-install` (the modern flag, supported by npm 7+) makes
 * the check purely local: it succeeds if the package is in npx's local
 * cache, fails fast with "missing packages and no YES option" if it is
 * not. The candidate's first interactive launch will then download the
 * package at a time when they're prepared for it (and the spinner is
 * visible).
 */
export async function isNpxPackageAvailable(pkg: string): Promise<boolean> {
  try {
    await execFileAsync('npx', ['--no-install', pkg, '--version'], { timeout: 3000 })
    return true
  } catch {
    return false
  }
}
